import axios from 'axios';
import { toastNotifyError } from 'src/components/Common/Toast';
import { ENDPOINT } from 'src/config/endpoints';

export const uploadCustomerMediaToS3 = async ({ payload, authToken, callback, type }) => {
  try {
    const forVideo = type === 'video';
    const config = {
      headers: {
        auth_token: authToken,
        app_os: 'cfe',
        app_version: '0.1.0',
        'Content-Type': !forVideo ? 'application/json' : 'multipart/form-data',
      },
    };
    const response = await axios.post(
      ENDPOINT.LOGS.UPLOAD_CUSTOMER_MEDIA_TO_S3,
      payload,
      config
    );
    if (response && response?.data?.status) {
      const imageURL = JSON.parse(response?.data?.data);
      callback && callback(imageURL);
      return imageURL;
    } else {
      toastNotifyError(response?.data?.message || 'Something went wrong!');
      callback && callback({ error: true });
      return { error: true, errorMessage: response?.data?.message || '' };
    }
  } catch (error) {
    const errorMessage = error?.response?.data?.message || '';
    callback && callback({ error: true, errorMessage });
    return { error: true, errorMessage };
  }
};
